import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import HatSchool from '../../assets/icons/hatSchool.svg';
import IconStar from '../../assets/icons/iconStar.svg';
import IconMap from '../../assets/icons/iconMap.svg';
import usersIcon from '../../assets/images/users.svg';
import AdminMenuOpt1 from '../../assets/images/admin-opt-1.png';
import AdminMenuOpt2 from '../../assets/images/admin-opt-2.png';
import AdminMenuOpt3 from '../../assets/images/admin-opt-3.png';
import AdminMenuOpt4 from '../../assets/images/admin-opt-4.png';
import { buildAdminPathWithScope } from '../../utils/adminScope';

import './style.scss';

function AdminSchoolMenu() {
  useEffect(() => {
    function pushAdminHistoryGuard() {
      window.history.pushState(
        { adminRootGuard: true },
        document.title,
        window.location.href
      );
    }

    pushAdminHistoryGuard();

    function handlePopState() {
      pushAdminHistoryGuard();
    }

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return (
    <section className='admin-menu'>
      <div className='admin-menu__general-actions'>
        <Link
          to={buildAdminPathWithScope('/administrador/avances', 'general')}
          className='admin-menu__general-dashboard'>
          <span className='material-symbols-rounded' aria-hidden='true'>
            monitoring
          </span>
          Panel general de los procesos
        </Link>

        <Link
          to={buildAdminPathWithScope(
            '/administrador/menu/calendario',
            'general'
          )}
          className='admin-menu__general-dashboard admin-menu__general-dashboard--calendar'>
          <span className='material-symbols-rounded' aria-hidden='true'>
            calendar_month
          </span>
          Calendario general
        </Link>

        <Link
          to='/administrador/semaforo'
          className='admin-menu__general-dashboard admin-menu__general-dashboard--traffic-light'>
          <span className='material-symbols-rounded' aria-hidden='true'>
            traffic
          </span>
          Semáforo
        </Link>
      </div>

      <div className='admin-menu__wrapper content'>
        <Link
          to={buildAdminPathWithScope('/administrador/menu', 'general')}
          className='content__item item item--schools'>
          <div className='item__def def'>
            <span className='def__text'>Procesos Formativos - General</span>
            <img src={HatSchool} alt='opt-1-icon' className='def__icon' />
          </div>
          <img src={AdminMenuOpt1} alt='opt-1' className='item__img' />
        </Link>

        <Link
          to={buildAdminPathWithScope('/administrador/menu', 'cop')}
          className='content__item item item--cop'>
          <div className='item__def def'>
            <span className='def__text'>Centro de Orientacion Pedagogica</span>
            <img src={IconStar} alt='opt-2-icon' className='def__icon' />
          </div>
          <img src={AdminMenuOpt2} alt='opt-2' className='item__img' />
        </Link>

        <Link
          to='/administrador/menu?view=divided'
          className='content__item item item--ndn'>
          <div className='item__def def'>
            <span className='def__text'>Procesos Formativos - Divididos</span>
            <img src={IconMap} alt='opt-3-icon' className='def__icon' />
          </div>
          <img src={AdminMenuOpt3} alt='opt-3' className='item__img' />
        </Link>

        <Link
          to='/administrador/visitas-territorio'
          className='content__item item'>
          <div className='item__def def'>
            <span className='def__text'>
              Visitas a actividades en territorio
            </span>
            <img src={usersIcon} alt='opt-4-icon' className='def__icon' />
          </div>
          <img src={AdminMenuOpt4} alt='opt-4' className='item__img' />
        </Link>

        <Link
          to={buildAdminPathWithScope('/administrador/menu', 'cs')}
          className='admin-menu__social-control'
          aria-label='Abrir Control Social'
          title='Control Social'>
          <span className='material-symbols-rounded' aria-hidden='true'>
            diversity_3
          </span>
          <span>Control Social</span>
        </Link>
      </div>
    </section>
  );
}

export default AdminSchoolMenu;
